import { AspectRatio, Box, Flex, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const ReviewItem = ({
  title,
  description
}: {
  title: string
  description: string
}) => {
  return (
    <VStack
      bg="white"
      py={6}
      px={4}
      my={4}
      borderRadius={10}
      w={{
        base: 300,
        lg: 400,
        xl: 500
      }}
      alignItems="flex-start"
      boxShadow="0px 0px 10px 2px rgba(0, 0, 0, 0.25)"
    >
      <AspectRatio
        w={{
          base: 100,
          lg: 140
        }}
        ratio={100 / 16}
        position="relative"
      >
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/stars-1711000517589.png"
          alt="Stars"
          fill
        />
      </AspectRatio>
      <Text textStyle="gripContentSmall" fontWeight={700}>
        {title}
      </Text>

      <Text textStyle="gripReviewItemDesc">{description}</Text>
    </VStack>
  )
}

const Review = () => {
  return (
    <VStack pb={10} alignItems="center">
      <VStack
        mt={20}
        w={{
          base: 600,
          lg: 900
        }}
        alignItems={{
          base: 'center',
          md: 'flex-start'
        }}
        justifyContent="flex-start"
      >
        <Text textStyle="gripMainTitle" fontWeight={400}>
          What They Say About
        </Text>

        <Text
          textTransform="uppercase"
          textStyle="gripMainTitle"
          textAlign={{
            base: 'center',
            md: 'left'
          }}
        >
          ARCTIC GRIP TUMBLER
        </Text>
      </VStack>

      <Flex
        justifyContent="space-between"
        alignItems="center"
        flexDir={{
          base: 'column',
          md: 'row'
        }}
        gap={{
          base: 0,
          md: 10
        }}
      >
        <AspectRatio
          w={{
            base: 180,
            md: 250,
            lg: 350,
            xl: 400
          }}
          ratio={248 / 480}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-review-1711955976219.png"
            alt="tumbler review"
            fill
          />
        </AspectRatio>

        <Box>
          <ReviewItem
            title="Great Product !"
            description="Works on both types of surfaces, especially on wooden surfaces used in common tables."
          />
          <ReviewItem
            title="Love This !!!"
            description="This keeps my beverages cold and the ice is still in the cup the next day. Well insulated and also keeps my coffee and tea as warm as first poured."
          />
          <ReviewItem
            title="Great quality mug!!!!"
            description="Easy to close up for travel and the lid makes it practically spill proof when I use it at my desk at the office."
          />
        </Box>
      </Flex>
    </VStack>
  )
}
export default Review
